import { sendHttpRequest } from "lib/fetcher";

export function updateOperatorReceiveStatus(status, sessionId) {
  return sendHttpRequest({
    url: `/queue/queues/receive`,
    method: "POST",
    data: { operation: status ? "op_start" : "op_end", sessionId },
  });
}
export function updateOperatorOnlineStatus(status, sessionId) {
  return sendHttpRequest({
    url: `/queue/queues/work`,
    method: "POST",
    data: { operation: status ? "op_start" : "op_end", sessionId },
  });
}
export function getOperatorStatus() {
  return sendHttpRequest({
    url: `/queue/queues/operator_status`,
    method: "GET",
  });
}
export function subscribeToAlertQueue(sessionId) {
  return sendHttpRequest({
    url: `/queue/queues/subscribe`,
    method: "POST",
    data: { sessionId },
  });
}
export function unsubscribeFromAlertQueue(sessionId) {
  return sendHttpRequest({
    url: `/queue/queues/unsubscribe`,
    method: "POST",
    data: { sessionId },
  });
}
